/* Mabel & Finn: sticky koopbalk onderin op elke productpagina (snippet mf-sticky-atc).
   Verschijnt zodra de echte koopknop uit beeld is gescrold en klikt bij een tik gewoon die knop aan,
   zodat variant, bundel en winkelwagen precies zo werken als bovenaan. Neemt kleur, hoeken en
   lettertype van die knop over, dus op een LP-kopie in de stijl van de LP en op de gewone
   productpagina in die van het thema. Prijs en doorgestreepte prijs lopen mee met de keuze. */
(function () {
  const bar = document.querySelector('.mf-sticky');
  if (!bar) return;
  const lp = bar.dataset.mode === 'lp';

  // De echte knop en waar de prijs staat, per soort pagina. Steeds opnieuw opzoeken: het thema
  // vervangt de knop soms bij een variantwissel, en dan mag de balk niet aan een oude knop hangen.
  const zoekKnop = () =>
    lp
      ? document.querySelector('.sp_buy_now') || document.querySelector('.js-add-to-cart')
      : document.querySelector('#MainContent product-info button[name="add"]') ||
        document.querySelector('#MainContent button[name="add"]');
  let target = zoekKnop();
  if (!target) return;
  const zoekPrijs = () => (lp ? null : document.querySelector('#MainContent [id^="price-"][role="status"]'));

  const button = bar.querySelector('.mf-sticky__btn');
  const label = bar.querySelector('.mf-sticky__label');
  const now = bar.querySelector('.mf-sticky__now');
  const was = bar.querySelector('.mf-sticky__was');
  const off = bar.querySelector('.mf-sticky__off');
  const stock = bar.querySelector('.mf-sticky__stock');

  function getal(tekst) {
    const m = (tekst || '').replace(/[\s ]/g, '').match(/\d+(?:[.,]\d{3})*(?:[.,]\d{1,2})?/);
    if (!m) return null;
    let s = m[0];
    const dec = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    if (dec >= 0 && s.length - dec - 1 <= 2) s = s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1);
    else s = s.replace(/[.,]/g, '');
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }

  function leesPrijs() {
    const priceBlock = zoekPrijs();
    if (lp) {
      return {
        now: document.getElementById('sp_price1')?.textContent.trim() || '',
        was: document.getElementById('sp_price2')?.textContent.trim() || '',
      };
    }
    // Gekozen bundel staat op de knop (quantity-breaks), anders de prijs van de variant.
    const qb = target.querySelector('.quantity-breaks__button-price');
    if (qb && qb.textContent.trim()) {
      return { now: qb.querySelector('span')?.textContent.trim() || '', was: qb.querySelector('s')?.textContent.trim() || '' };
    }
    if (!priceBlock) return { now: '', was: '' };
    const sale = priceBlock.querySelector('.price--on-sale');
    if (sale) {
      return {
        now: sale.querySelector('.price__sale .price-item--sale')?.textContent.trim() || '',
        was: sale.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular')?.textContent.trim() || '',
      };
    }
    return { now: priceBlock.querySelector('.price-item--regular')?.textContent.trim() || '', was: '' };
  }

  function knopTekst() {
    if (lp) {
      const t = target.querySelector('.js-in-stock-text');
      if (t && getComputedStyle(t).display !== 'none') return t.textContent.trim();
    }
    const eerste = target.querySelector('span');
    return (eerste ? eerste.textContent : target.textContent).replace(/\s+/g, ' ').trim();
  }

  function sync() {
    target = zoekKnop() || target;
    const p = leesPrijs();
    now.textContent = p.now;
    const n = getal(p.now), w = getal(p.was);
    // Logisch percentage (B97): op 5 afgerond, max. 70%, zoals de prijsbadge op de pagina.
    const korting = n && w && w > n ? Math.min(70, Math.round(((w - n) / w) * 20) * 5) : 0;
    was.textContent = korting ? p.was : '';
    off.textContent = bar.dataset.deal || (korting ? '-' + korting + '%' : '');
    off.hidden = !off.textContent;
    pas();
    label.textContent = knopTekst() || label.textContent;
    const uit = target.disabled || target.getAttribute('aria-disabled') === 'true';
    button.disabled = uit;
    // Zelfde voorraadregel als op de pagina ("Last pieces available"), klein onder de knop. Geen regel op de pagina = geen regel hier.
    // Alleen het deel voor " · " (bv. "Last pieces · Order by 4 Dec for Christmas"), anders drukt de regel de prijs weg.
    const pulse = document.querySelector('#MainContent .bs-stock-pulse__text');
    const tekst = !uit && pulse ? pulse.textContent.split('·')[0].trim() : '';
    stock.querySelector('.mf-sticky__stock-text').textContent = tekst;
    stock.hidden = !tekst;
  }

  // Stijl van de echte knop overnemen.
  function stijl() {
    const c = getComputedStyle(target);
    const leeg = (k) => !k || k === 'rgba(0, 0, 0, 0)' || k === 'transparent';
    let bg = c.backgroundColor;
    // Shrine kleurt de knop via ::after (de knop zelf is transparant), dus daar ook kijken.
    if (leeg(bg)) bg = getComputedStyle(target, '::after').backgroundColor;
    if (leeg(bg)) bg = getComputedStyle(target, '::before').backgroundColor;
    if (leeg(bg)) bg = c.color === 'rgb(255, 255, 255)' ? '#111' : bg;
    bar.style.setProperty('--mf-btn-bg', bg);
    bar.style.setProperty('--mf-btn-fg', c.color);
    bar.style.setProperty('--mf-btn-radius', c.borderRadius);
    bar.style.setProperty('--mf-btn-font', c.fontFamily);
    bar.style.setProperty('--mf-btn-weight', c.fontWeight);
    bar.style.setProperty('--mf-btn-case', c.textTransform);
    bar.style.setProperty('--mf-btn-spacing', c.letterSpacing);
  }

  // Past de prijsregel niet (smalle telefoon), dan valt de doorgestreepte prijs weg, niet de deal (Rik 26 okt).
  // Meten kan pas als de balk opgemaakt is, dus ook bij tonen en bij draaien van het scherm.
  function pas() {
    const regel = now.parentElement;
    was.hidden = !was.textContent;
    if (regel.clientWidth && regel.scrollWidth > regel.clientWidth + 1) was.hidden = true;
  }

  let zichtbaar = false;
  function toon(aan) {
    if (aan === zichtbaar) return;
    zichtbaar = aan;
    bar.classList.toggle('is-visible', aan);
    bar.setAttribute('aria-hidden', String(!aan));
    button.tabIndex = aan ? 0 : -1;
    document.body.style.paddingBottom = aan ? bar.offsetHeight + 'px' : '';
    if (aan) requestAnimationFrame(pas);
  }

  // Zichtbaar zodra je voorbij het eerste scherm bent en de echte knop niet in beeld staat,
  // dus ook op een LP waar de koopknop pas ver onderaan komt.
  let gepland = false;
  function check() {
    gepland = false;
    const t = zoekKnop() || target;
    const r = t.getBoundingClientRect();
    const inBeeld = r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
    toon(!inBeeld && window.scrollY > window.innerHeight * 0.5);
  }
  const plan = () => { if (!gepland) { gepland = true; requestAnimationFrame(check); } };
  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan);

  button.addEventListener('click', () => {
    if (button.disabled) return;
    (zoekKnop() || target).click();
  });

  stijl();
  sync();
  // Meelopen met variant, bundel en voorraad: kijk naar het hele koopblok, niet alleen naar de knop.
  const blok = lp
    ? target.closest('.js-pricing-v2') || document.getElementById('d2c-landing-root')
    : target.closest('product-info') || document.getElementById('MainContent');
  let syncGepland = false;
  new MutationObserver(() => {
    if (syncGepland) return;
    syncGepland = true;
    requestAnimationFrame(() => { syncGepland = false; sync(); });
  }).observe(blok, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  bar.hidden = false;
  check();
})();
